<template>
  <div id="cd-category-offered">
    <span v-for="categorieOffered in categories" :key="categorieOffered.name">
      <i :id="categorieOffered.name + categorieOffered.id" class="bushel-icon bushel-2x mb-2" :class="productIcon(categorieOffered.name)" />
      <BTooltip :target="categorieOffered.name + categorieOffered.id" triggers="hover">
        {{ categorieOffered.name }}
      </BTooltip>
    </span>
  </div>
</template>

<script>
import { productIcon } from "@/services/applicationSpecificHelpers";

export default {
  props: {
    categories: { type: Array, required: true },
  },
  methods: {
    productIcon,
  },
};
</script>

<style lang="scss" scoped>
#cd-category-offered {
  transform: translateX(-0.75rem);

  i {
    width: 1.5em;
    height: 1.5em;
    margin: 0 !important;
    font-size: 2rem;
  }
}
</style>
